import React, { useState } from "react";
import {
  CardCvcElement,
  CardCvcElementComponent,
  CardExpiryElement,
  CardExpiryElementComponent,
  CardNumberElement,
  CardNumberElementComponent,
} from "@stripe/react-stripe-js";
import {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent,
  StripeCardNumberElementOptions,
} from "@stripe/stripe-js";
import { Icon } from "@/components";
import { colors } from "@/offering_v2/components/colors";
import classNames from "classnames";

interface PortalPaymentFormProps {
  nameOnCard: string;
  nameOnCardError?: string;
  setNameOnCard: (value: string) => void;
}

export function PortalPaymentForm({
  nameOnCard,
  nameOnCardError,
  setNameOnCard,
}: PortalPaymentFormProps) {
  return (
    <div>
      <PortalPaymentFormStripeInput
        label="CARD NUMBER"
        StripeCardInputElement={CardNumberElement}
      />
      <div className="row mt-2">
        <div className="col-6">
          <PortalPaymentFormStripeInput
            label="EXPIRATION"
            StripeCardInputElement={CardExpiryElement}
          />
        </div>
        <div className="col-6">
          <PortalPaymentFormStripeInput
            label="CVC"
            StripeCardInputElement={CardCvcElement}
          />
        </div>
      </div>
      <div className="mt-2">
        <label className="fw-semibold">
          NAME ON CARD <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className={classNames(
            nameOnCardError ? "border-danger" : "border-secondary-subtle",
            "w-100 mt-1 p-2 px-3 fs-large rounded border"
          )}
          value={nameOnCard}
          onChange={(event) => setNameOnCard(event.target.value)}
        />
        {nameOnCardError && (
          <div
            className="mt-1 d-flex gap-1"
            style={{ color: colors.grapefruitCore }}
          >
            <div>
              <Icon name="filled-info" color="#FF595A" size={16} />
            </div>{" "}
            {nameOnCardError}
          </div>
        )}
      </div>
    </div>
  );
}

interface PortalPaymentFormStripeInputProps {
  label: string;
  StripeCardInputElement:
    | CardNumberElementComponent
    | CardExpiryElementComponent
    | CardCvcElementComponent;
}

function PortalPaymentFormStripeInput({
  label,
  StripeCardInputElement,
}: PortalPaymentFormStripeInputProps) {
  const [error, setError] = useState<string>();

  const inputBorderClasses = classNames(
    error ? "border-danger" : "border-secondary-subtle",
    "w-100 mt-1 p-2 px-3 rounded border"
  );
  const cardInputOptions: StripeCardNumberElementOptions = {
    style: { base: { fontSize: "16px", lineHeight: "24px" } },
    showIcon: true,
  };

  const handleChangeCardInput = (
    event:
      | StripeCardNumberElementChangeEvent
      | StripeCardExpiryElementChangeEvent
      | StripeCardCvcElementChangeEvent
  ) => {
    if (event.error) {
      setError(event.error.message);
    } else {
      setError(undefined);
    }
  };

  return (
    <div>
      <label className="fw-semibold">
        {label} <span className="text-danger">*</span>
      </label>
      <div className={inputBorderClasses}>
        <StripeCardInputElement
          options={cardInputOptions}
          onChange={handleChangeCardInput}
        />
      </div>
      {error && (
        <div
          className="mt-1 d-flex gap-1"
          style={{ color: colors.grapefruitCore }}
        >
          <div>
            <Icon name="filled-info" color="#FF595A" size={16} />
          </div>{" "}
          {error}
        </div>
      )}
    </div>
  );
}
